import { useState } from "react";
import { X, Users, FileText, Image } from "lucide-react";
import styles from "./CreateCommunityModal.module.css";

/* Modal for creating a new Community — the single canonical implementation
   used by both Home.jsx's own flow and Communities.jsx's "New Community"
   button. (This used to be duplicated in components/NewCommunity.jsx with
   near-identical code; that file has been removed in favor of this one.)
   Deliberately does NOT generate a client-side id: onCreateCommunity's
   Firestore write (createCommunity in meetlyService.js) uses addDoc, which
   assigns the real document id — adding one here would create a stray
   "id" field inside the document data itself. */
export function CreateCommunityModal({ isOpen, onClose, onCreateCommunity }) {
  if (!isOpen) return null;

  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");
  const [image, setImage] = useState("");

  // Build the new community object and reset the form on successful submit.
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim() || !desc.trim()) return;

    onCreateCommunity({
      name,
      members: "1 member",
      desc,
      // Fall back to a stock cover photo if the user didn't provide one.
      image:
        image.trim() ||
        "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=500&auto=format&fit=crop&q=60",
    });
    setName("");
    setDesc("");
    setImage("");
    onClose();
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.headerRow}>
          <h3 className={styles.title}>Create Community</h3>
          <button onClick={onClose} className={styles.closeButton}>
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div>
            <label className={styles.fieldLabel}>Community Name</label>
            <div className={styles.inputWithIcon}>
              <Users size={16} />
              <input
                type="text"
                required
                placeholder="e.g. Dublin Photographers"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
          </div>

          <div>
            <label className={styles.fieldLabel}>Description</label>
            <div className={styles.inputWithIcon}>
              <FileText size={16} />
              <textarea
                required
                rows="3"
                placeholder="What brings this community together?"
                value={desc}
                onChange={(e) => setDesc(e.target.value)}
              />
            </div>
          </div>

          <div>
            <label className={styles.fieldLabel}>Image URL (Optional)</label>
            <div className={styles.inputWithIcon}>
              <Image size={16} />
              <input
                type="url"
                placeholder="https://images.unsplash.com/..."
                value={image}
                onChange={(e) => setImage(e.target.value)}
              />
            </div>
          </div>

          <button type="submit" className={styles.submitButton}>
            Create Community
          </button>
        </form>
      </div>
    </div>
  );
}

